module.exports = __webpack_public_path__ + "img/supplier-trade-statistic-active.a4050dbd.png";